import { useState } from "react";
import { IPagination } from "../data/AppInterface";

interface IUsePaginationProps {
  pagination?: Omit<IPagination, "totalItems" | "totalPages">;
}

const INITIAL_PAGINATION: IPagination = {
  perPageRows: 10,
  currentPage: 1,
  sortBy: "id",
  orderBy: "DESC",
  totalPages: 0,
  totalItems: 0,
};

const UsePaginationHook = (props?: IUsePaginationProps) => {
  const [pagination, setPagination] = useState({
    ...INITIAL_PAGINATION,
    ...(props?.pagination ? props.pagination : {}),
  });

  const setChangePagination = (value: IPagination) => {
    setPagination(value);
  };
  return { pagination, setChangePagination };
};

export default UsePaginationHook;
